module.exports = __webpack_public_path__ + "media/me-too.a6b4932b.ogg";